import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const [mobileProgramsOpen, setMobileProgramsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'CFN', href: '/cfn' },
    { name: 'Training', href: '/training' },
    { name: 'Events', href: '/events' },
    { name: 'Resources', href: '/resources' },
    { name: 'Contact', href: '/contact' }
  ];

  return (
    <header className="bg-white shadow-lg sticky top-0 z-40">
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-12 h-12 rounded-full overflow-hidden flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/0f4196e35f78d87056a996d208b7f641/2a01936c71991026fb04439a944e88b7.jpeg" 
                  alt="PAAM Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Pacifico, serif' }}>
                  PAAM
                </h1>
                <p className="text-xs text-gray-600">Christ + Nothing = Enough</p>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-[#b8144a] font-medium transition-colors">
              Home
            </Link>
            
            <div className="relative group">
              <button className="text-gray-700 hover:text-[#b8144a] font-medium transition-colors flex items-center">
                About
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="py-2">
                  <Link to="/about" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    About PAAM
                  </Link>
                  <Link to="/leadership" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    Leadership
                  </Link>
                </div>
              </div>
            </div>

            <div className="relative group">
              <button className="text-gray-700 hover:text-[#b8144a] font-medium transition-colors flex items-center">
                Programs
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="py-2">
                  <Link to="/programs" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    All Programs
                  </Link>
                  <Link to="/cfn" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    Christ Family Network
                  </Link>
                  <Link to="/one-fold" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    One Fold Network
                  </Link>
                  <Link to="/ecclesia" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    Ecclesia of Believers
                  </Link>
                  <Link to="/convention" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    ABIC Convention
                  </Link>
                  <Link to="/missions" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    Root and Reign Mission
                  </Link>
                  <Link to="/medical-mission" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    Meal and Medical Mission
                  </Link>
                  <Link to="/publications" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    Gallery of Revelation
                  </Link>
                  <Link to="/crusades" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    Christ Gospel Crusade
                  </Link>
                  <Link to="/rallies" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#b8144a] transition-colors">
                    Jesus Christ Rally
                  </Link>
                </div>
              </div>
            </div>

            <Link to="/events" className="text-gray-700 hover:text-[#b8144a] font-medium transition-colors">
              Events
            </Link>

            <Link to="/resources" className="text-gray-700 hover:text-[#b8144a] font-medium transition-colors">
              Resources
            </Link>

            <Link to="/live-streaming" className="text-gray-700 hover:text-[#b8144a] font-medium transition-colors">
              Live
            </Link>

            <Link to="/training" className="text-gray-700 hover:text-[#b8144a] font-medium transition-colors">
              Training
            </Link>

            <Link to="/contact" className="text-gray-700 hover:text-[#b8144a] font-medium transition-colors">
              Contact
            </Link>
          </div>

          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="https://portal.paamintl.org/"
              
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-[#b8144a] font-medium transition-colors duration-200 cursor-pointer"
            >
              Login
            </a>
            <Link
              to="/join"
              className="bg-[#b8144a] hover:bg-[#a01240] text-white px-6 py-2 rounded-full font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Join CFN
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#b8144a] p-2 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className={`text-sm font-medium transition-colors duration-200 hover:text-[#b8144a] ${
                  location.pathname === '/' ? 'text-[#b8144a]' : 'text-gray-700'
                }`}
              >
                Home
              </Link>
              
              {/* About Dropdown */}
              <div>
                <button
                  onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
                  className="w-full flex items-center justify-between text-sm font-medium text-gray-700 hover:text-[#b8144a] transition-colors cursor-pointer"
                >
                  <span>About</span>
                  <i className={`ri-arrow-${mobileAboutOpen ? 'up' : 'down'}-s-line`}></i>
                </button>
                {mobileAboutOpen && (
                  <div className="mt-2 ml-4 space-y-2">
                    <Link
                      to="/about"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      About PAAM
                    </Link>
                    <Link
                      to="/leadership"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      Leadership
                    </Link>
                  </div>
                )}
              </div>

              {/* Programs Dropdown */}
              <div>
                <button
                  onClick={() => setMobileProgramsOpen(!mobileProgramsOpen)}
                  className="w-full flex items-center justify-between text-sm font-medium text-gray-700 hover:text-[#b8144a] transition-colors cursor-pointer"
                >
                  <span>Programs</span>
                  <i className={`ri-arrow-${mobileProgramsOpen ? 'up' : 'down'}-s-line`}></i>
                </button>
                {mobileProgramsOpen && (
                  <div className="mt-2 ml-4 space-y-2">
                    <Link
                      to="/programs"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      All Programs
                    </Link>
                    <Link
                      to="/cfn"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      Christ Family Network
                    </Link>
                    <Link
                      to="/one-fold"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      One Fold Network
                    </Link>
                    <Link
                      to="/ecclesia"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      Ecclesia of Believers
                    </Link>
                    <Link
                      to="/convention"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      ABIC Convention
                    </Link>
                    <Link
                      to="/missions"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      Root and Reign Mission
                    </Link>
                    <Link
                      to="/medical-mission"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      Meal and Medical Mission
                    </Link>
                    <Link
                      to="/publications"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      Gallery of Revelation
                    </Link>
                    <Link
                      to="/crusades"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      Christ Gospel Crusade
                    </Link>
                    <Link
                      to="/rallies"
                      onClick={() => setIsMenuOpen(false)}
                      className="block text-sm text-gray-600 hover:text-[#b8144a] transition-colors"
                    >
                      Jesus Christ Rally
                    </Link>
                  </div>
                )}
              </div>
              
              <Link
                to="/events"
                onClick={() => setIsMenuOpen(false)}
                className={`text-sm font-medium transition-colors duration-200 hover:text-[#b8144a] ${
                  location.pathname === '/events' ? 'text-[#b8144a]' : 'text-gray-700'
                }`}
              >
                Events
              </Link>

              <Link
                to="/resources"
                onClick={() => setIsMenuOpen(false)}
                className={`text-sm font-medium transition-colors duration-200 hover:text-[#b8144a] ${
                  location.pathname === '/resources' ? 'text-[#b8144a]' : 'text-gray-700'
                }`}
              >
                Resources
              </Link>

              <Link
                to="/live-streaming"
                onClick={() => setIsMenuOpen(false)}
                className={`text-sm font-medium transition-colors duration-200 hover:text-[#b8144a] ${
                  location.pathname === '/live-streaming' ? 'text-[#b8144a]' : 'text-gray-700'
                }`}
              >
                Live
              </Link>
              
              <Link
                to="/training"
                onClick={() => setIsMenuOpen(false)}
                className={`text-sm font-medium transition-colors duration-200 hover:text-[#b8144a] ${
                  location.pathname === '/training' ? 'text-[#b8144a]' : 'text-gray-700'
                }`}
              >
                Training
              </Link>
              
              <Link
                to="/contact"
                onClick={() => setIsMenuOpen(false)}
                className={`text-sm font-medium transition-colors duration-200 hover:text-[#b8144a] ${
                  location.pathname === '/contact' ? 'text-[#b8144a]' : 'text-gray-700'
                }`}
              >
                Contact
              </Link>
              
              <a
                href="https://portal.paamintl.org/"
                
                rel="noopener noreferrer"
                onClick={() => setIsMenuOpen(false)}
                className="text-sm font-medium transition-colors duration-200 hover:text-[#b8144a] text-gray-700"
              >
                Login
              </a>
              
              <Link
                to="/join"
                onClick={() => setIsMenuOpen(false)}
                className="bg-[#b8144a] hover:bg-[#a01240] text-white px-6 py-2 rounded-full font-medium transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                Join CFN
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
